import createAction, { createClearAction } from '../../app/createAction';
import {
    ACCOUNT_GET_PORTFOLIO_FAILURE,
    ACCOUNT_GET_PORTFOLIO_START,
    ACCOUNT_GET_PORTFOLIO_SUCCESS,
    ACCOUNT_GET_TRADING_TOKEN_FAILURE,
    ACCOUNT_GET_TRADING_TOKEN_START,
    ACCOUNT_GET_TRADING_TOKEN_SUCCESS,
    PAYOUT_TRANSACTIONS_FAILURE,
    PAYOUT_TRANSACTIONS_START,
    PAYOUT_TRANSACTIONS_SUCCESS,
    REFILL_DEMO_FAILURE,
    REFILL_DEMO_START,
    REFILL_DEMO_SUCCESS,
    RESEND_USER_CONFIRM_EMAIL_FAILURE,
    RESEND_USER_CONFIRM_EMAIL_START,
    RESEND_USER_CONFIRM_EMAIL_SUCCESS,
    RESET_ACCOUNT_ERROR,
    SET_ACCOUNT_SELECTED_HISTORY_INFO,
    SET_CONFIRM_EMAIL_REQUEST_TIME,
} from './accountConstants';
import type {
    IAccountHistoryInfo,
    IAccountPortfolio,
    IPayloadTransaction,
    ITradingToken,
} from './types/accountActions.t';

export const accountGetPortfolioAction = () => createClearAction<typeof ACCOUNT_GET_PORTFOLIO_START>(ACCOUNT_GET_PORTFOLIO_START);

export const accountGetPortfolioSuccess = (payload: IAccountPortfolio) => createAction<typeof ACCOUNT_GET_PORTFOLIO_SUCCESS, IAccountPortfolio>(ACCOUNT_GET_PORTFOLIO_SUCCESS, payload);
export const accountGetPortfolioFailure = (payload: {}) => createAction<typeof ACCOUNT_GET_PORTFOLIO_FAILURE, {}>(ACCOUNT_GET_PORTFOLIO_FAILURE, payload);

export const accountGetTradingTokenAction = (payload?: unknown) => createClearAction<typeof ACCOUNT_GET_TRADING_TOKEN_START>(ACCOUNT_GET_TRADING_TOKEN_START, payload);
export const accountGetTradingTokenSuccess = (payload: ITradingToken) => createAction<typeof ACCOUNT_GET_TRADING_TOKEN_SUCCESS, ITradingToken>(ACCOUNT_GET_TRADING_TOKEN_SUCCESS, payload);
export const accountGetTradingTokenFailure = (payload?: unknown) => createClearAction<typeof ACCOUNT_GET_TRADING_TOKEN_FAILURE>(ACCOUNT_GET_TRADING_TOKEN_FAILURE, payload);

export const payoutGetTransactionsAction = () => createClearAction<typeof PAYOUT_TRANSACTIONS_START>(PAYOUT_TRANSACTIONS_START);
export const payoutGetTransactionsSuccess = (payload: IPayloadTransaction) => createAction<typeof PAYOUT_TRANSACTIONS_SUCCESS, IPayloadTransaction>(PAYOUT_TRANSACTIONS_SUCCESS, payload);
export const payoutGetTransactionsFailure = (payload: {}) => createAction<typeof PAYOUT_TRANSACTIONS_FAILURE, {}>(PAYOUT_TRANSACTIONS_FAILURE, payload);

export const resetAccountErrorAction = (payload: {}) => createAction<typeof RESET_ACCOUNT_ERROR, {}>(RESET_ACCOUNT_ERROR, payload);

export const resendUserConfirmEmailAction = (payload?: unknown) => createAction<typeof RESEND_USER_CONFIRM_EMAIL_START, unknown>(RESEND_USER_CONFIRM_EMAIL_START, payload);
export const resendUserConfirmEmailSuccess = (payload?: unknown) => createClearAction<typeof RESEND_USER_CONFIRM_EMAIL_SUCCESS>(RESEND_USER_CONFIRM_EMAIL_SUCCESS, payload);
export const resendUserConfirmEmailFailure = (payload: {}) => createAction<typeof RESEND_USER_CONFIRM_EMAIL_FAILURE, {}>(RESEND_USER_CONFIRM_EMAIL_FAILURE, payload);

export const setConfirmEmailRequestedTimeAction = (payload: string) => createAction<typeof SET_CONFIRM_EMAIL_REQUEST_TIME, string>(SET_CONFIRM_EMAIL_REQUEST_TIME, payload);

export const setAccountSelectedHistoryInfoAction = (payload: IAccountHistoryInfo) => createAction<typeof SET_ACCOUNT_SELECTED_HISTORY_INFO, IAccountHistoryInfo>(SET_ACCOUNT_SELECTED_HISTORY_INFO, payload);

export const refillDemoAction = () => createClearAction<typeof REFILL_DEMO_START>(REFILL_DEMO_START);
export const refillDemoSuccess = () => createClearAction<typeof REFILL_DEMO_SUCCESS>(REFILL_DEMO_SUCCESS);
export const refillDemoFailure = () => createClearAction<typeof REFILL_DEMO_FAILURE>(REFILL_DEMO_FAILURE);
